var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 24-12.514-.04.007-1.512 10.917.033V1.577H11.493V.06H24V24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.309 11.197H0v1.513h16.354l-2.8 2.799 1.147 1.043 3.84-3.842h.052v-.054l.713-.712-.713-.69v-.056h-.057L14.7 7.48l-1.134 1.063 2.742 2.655Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Login.36e425e929acbe4c139c6768eafe93a5.svg";